const REDACTED_PLACEHOLDER = '<redacted>';
/**
 * Replace the whole string with <redacted> (no partial prefix).
 */
export function redactString(str) {
    return REDACTED_PLACEHOLDER;
}
const SENSITIVE_PARAM_KEYS = [
    'authorization',
    'Authorization',
    'auth',
    'token',
    'accessToken',
    'refreshToken',
    'AWSAccessKeyId',
    'X-Amz-Security-Token',
    'x-amz-security-token',
    'access_token',
    'username',
];
const SENSITIVE_PARAM_PATTERNS = SENSITIVE_PARAM_KEYS.map((key) => ({
    key,
    json: new RegExp(`("${key}"\\s*:\\s*")(.*?)(")`, 'giu'),
    query: new RegExp(`(${key})=([^&\\s]+)`, 'giu'),
    ablyLog: new RegExp(`(${key}\\s*:\\s*)([^;\\s]+)`, 'giu'),
}));
export const redactSensitiveString = (input) => {
    let result = input;
    for (const { json, query, ablyLog } of SENSITIVE_PARAM_PATTERNS) {
        result = result.replace(json, (_match, prefix, value, suffix) => `${prefix}${redactString(value)}${suffix}`);
        result = result.replace(query, (_match, paramName, paramValue) => `${paramName}=${redactString(paramValue)}`);
        result = result.replace(ablyLog, (_match, prefix, value) => `${prefix}${redactString(value)}`);
    }
    return result;
};
export const redactSensitiveFields = (value) => {
    if (value === null || value === undefined) {
        return value;
    }
    if (typeof value === 'string') {
        return redactSensitiveString(value);
    }
    if (typeof value === 'object') {
        const obj = value;
        for (const key of Object.keys(obj)) {
            const fieldValue = obj[key];
            if (SENSITIVE_PARAM_KEYS.includes(key)) {
                const asString = typeof fieldValue === 'string'
                    ? fieldValue
                    : fieldValue !== null && fieldValue !== undefined
                        ? String(fieldValue)
                        : '';
                obj[key] = redactString(asString);
                continue;
            }
            if (typeof fieldValue === 'string') {
                obj[key] = redactSensitiveString(fieldValue);
                continue;
            }
            if (fieldValue !== null && typeof fieldValue === 'object') {
                redactSensitiveFields(fieldValue);
            }
        }
    }
    return value;
};
